/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import { _ as o } from "../../chunks/tslib.es6.js";
import { ClonableMixin as r } from "../../core/Clonable.js";
import { JSONSupport as t } from "../../core/JSONSupport.js";
import { property as s } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { reader as e } from "../../core/accessorSupport/decorators/reader.js";
import { subclass as p } from "../../core/accessorSupport/decorators/subclass.js";
import { writer as i } from "../../core/accessorSupport/decorators/writer.js";
import { fromJSON as a } from "./domains.js";
let c = class extends r(t) {
  constructor(o) {
    super(o), this.code = null, this.defaultValues = {}, this.domains = null, this.name = null;
  }
  readDomains(o) {
    if (!o) return null;
    const r = {};
    for (const t of Object.keys(o)) r[t] = a(o[t]);
    return r;
  }
  writeDomains(o, r) {
    if (!o) return;
    const t = {};
    for (const s of Object.keys(o)) o[s] && (t[s] = o[s]?.toJSON());
    r.domains = t;
  }
};
o([s({
  type: Number,
  json: {
    write: !0
  }
})], c.prototype, "code", void 0), o([s({
  type: Object,
  json: {
    write: !0
  }
})], c.prototype, "defaultValues", void 0), o([s({
  json: {
    write: !0
  }
})], c.prototype, "domains", void 0), o([e("domains")], c.prototype, "readDomains", null), o([i("domains")], c.prototype, "writeDomains", null), o([s({
  type: String,
  json: {
    write: !0
  }
})], c.prototype, "name", void 0), c = o([p("esri.layers.support.Subtype")], c);
const n = c;
export { n as default };